import React, {useRef, useState, useEffect } from 'react';
import { Row, Col, Card, Button, Form } from 'react-bootstrap';
import classNames from 'classnames';
import Flex from '../../common/Flex';
import {contactType, listLicense} from '../../../lib/api/contact';
import {listUserClub} from "../../../lib/api/club";
import {edit, item, listPlayers} from "../../../lib/api/termination";
import AsyncSelect from "react-select/async";
import {format} from "date-fns";

export function Edit({ initTermination, initMode, onClose, onSave }) {

  console.log('initTermination',initTermination)
  const [club, setClub] = useState([]);
  const [mode, setMode] = useState(initMode);
  const [item, setItem] = useState(initTermination);
  const [selectedClubId, setSelectedClubId] = useState(initTermination.entities_id || '');
  const [termination, setTermination] = useState(initTermination);
  const [selectedPlayer, setSelectedPlayer] = useState([]);
  const [transferOption, setTransferOption] = useState('');
  const [errors, setErrors] = useState({entities_id: false, players_entities_id: false})

  useEffect(() => {
    (async () => {
      const _clubs = await listUserClub();
      const [_player] = await listPlayers({ entities_id: initTermination.players_entities_id });
      const _rows = _clubs.map(p => ({ ...p, value: p.club_id, label: p.name }));

      setClub(_rows);

      const transfer_option = initTermination.allow_transfer_any_club
          ? 'allow_transfer_any_club'
          : initTermination.allow_transfer_specific_club
              ? 'allow_transfer_specific_club'
              : '';

      const compensation_option = initTermination.tc_exempted
          ? 'tc_exempted'
          : initTermination.tc_paid
              ? 'tc_paid'
              : '';

      setItem({
        ...initTermination,
        transfer_option,
        compensation_option
      });

      setTransferOption(initTermination.allow_transfer_specific_club ? "allow_transfer_specific_club" : "allow_transfer_any_club")

      setSelectedClubId(initTermination.entities_id);

      setSelectedPlayer({
        value: _player.entities_id,
        label: _player.name,
        players_year: _player.players_year,
        is_home_club: _player.is_home_club
      });
    })();
  }, [initTermination]); // ← samo kada se promijeni početni termination

  const handelInput = e => {
    const { name, value, type, id } = e.target;

    // Ako je radio button, koristi mapiranje preko ID-a
    if (type === 'radio') {
      // Mapiranje id → item key
      const radioMap = {
        allow_transfer_any_club: { key: 'transfer_option', value: 'allow_transfer_any_club' },
        allow_transfer_specific_club: { key: 'transfer_option', value: 'allow_transfer_specific_club' },
        tc_exempted: { key: 'compensation_option', value: 'tc_exempted' },
        tc_paid: { key: 'compensation_option', value: 'tc_paid' }
      };

      const mapped = radioMap[id];
      if (mapped) {
        setItem(prev => ({
          ...prev,
          [mapped.key]: mapped.value
        }));

        if (mapped.key === 'transfer_option') {
          setTransferOption(mapped.value);
        }
      }
    } else {
      if (name === 'entities_id') {
        const value = e.target.value;
        setSelectedClubId(value);
        if (!value) setSelectedPlayer(null);
      }

      setItem(prev => ({
        ...prev,
        [name]: value
      }));
    }

    console.log('item', item);
  };


  const loadOptions = (inputValue, callback) => {
    if (inputValue.length < 3 || !selectedClubId) {
      return callback([]); // ne traži ništa dok nema 3 slova i izabran klub
    }


    console.log('selectedClubId',selectedClubId)

    try {
      listPlayers({name:inputValue, club_entities_id: selectedClubId})
          .then(response => {
            const options = response.map(item => ({
              value: item.entities_id,
              label: item.name + ' ('+ formatDateTime(item.date_of_birth)+')',
            }));
            callback(options);
          }).catch(err => {
        console.error(err);
        callback([]);
      });

    } catch (error) {
      console.error(error);
      callback([]);
    }
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);

    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // mjeseci idu od 0
    const yyyy = date.getFullYear();

    return `${dd}.${mm}.${yyyy}`;
  }

  const handleSubmit = async event => {
    event.preventDefault();
    const form = event.currentTarget;
    if (!validateForm(event)) return;

    const _data = {
      entities_id: item.entities_id,
      players_entities_id: item.players_entities_id,
      allow_transfer_any_club: item.transfer_option === 'allow_transfer_any_club' ? 1 : 0,
      allow_transfer_specific_club: item.transfer_option === 'allow_transfer_specific_club' ? 1 : 0,
      tc_exempted: item.compensation_option === 'tc_exempted' ? 1 : 0,
      tc_paid: item.compensation_option === 'tc_paid' ? 1 : 0
    };
    if (_data.allow_transfer_any_club === 1) _data['specific_club_entities_id'] = null;
    else _data['specific_club_entities_id'] = item.specific_club_entities_id;



    console.clear();
    console.log('_data',_data)
    console.log('item',item)
    await edit(_data, item.document_guid);
    onSave();
    onClose();
  };

  const validateForm = event => {
    const form = event.currentTarget;
    const newErrors = {
      entities_id: !item.entities_id,
      players_entities_id: !item.players_entities_id,
      transfer_option: !item.transfer_option,
      compensation_option:
          selectedPlayer &&
          selectedPlayer.players_year >= 14 &&
          selectedPlayer.players_year <= 17 &&
          selectedPlayer.is_home_club === 1 &&
          !item.compensation_option,
    };

    if (item.transfer_option === 'allow_transfer_specific_club' && !item.specific_club_entities_id) {
      newErrors.specific_club_entities_id = true;
    }

    setErrors(newErrors);

    if (Object.values(newErrors).some(error => error)) {
      event.stopPropagation();
      return false;
    }
    return true;
  };


  return (
      <Card>
        <Card.Body className="bg-body-tertiary">
          <Form
              method="POST"
              encType="multipart/form-data"
              noValidate
              onSubmit={handleSubmit}
          >
            <Row className="mb-3">
              <Form.Group as={Col} md="6" controlId="name">
                <Form.Label>Naziv</Form.Label>
                <Form.Control required type="text" name="name" value={"Prekid članstva"} disabled  />
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="date_created">
                <Form.Label>Datum</Form.Label>
                <Form.Control required type="text" value={format(new Date(), 'dd.MM.yyyy')} name="date_created" disabled />
              </Form.Group>
            </Row>


            <Row className="mb-3">
              <Form.Group as={Col} md="12" controlId="entities_id">
                <Form.Label>Klub</Form.Label>
                <Form.Select name="entities_id" required value={item.entities_id || ''} onChange={handelInput} isInvalid={errors.entities_id} disabled={mode !== 'edit'}>
                  {club.length > 1 && (
                      <option value="">Izaberi</option>
                  )}
                  {club.map(p => (
                      <option key={p.entities_id} value={p.entities_id}>
                        {p.name}
                      </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">Molimo izaberite klub.</Form.Control.Feedback>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} md="12" controlId="players_entities_id">
                <Form.Label>Igrač</Form.Label>
                <AsyncSelect name="players_entities_id"
                             cacheOptions
                             defaultOptions={false}
                             loadOptions={loadOptions}
                             placeholder="Pretraži..."
                             classNamePrefix="react-select"
                             onChange={(selected) => {
                               console.log('selected', selected)
                               handelInput({ target: { name: 'players_entities_id', value: selected.value } })
                               setSelectedPlayer(selected)
                             }}
                             value={selectedPlayer}
                             isDisabled={!selectedClubId || mode !== 'edit'}
                             isClearable={true}
                />
                {errors.players_entities_id && (
                    <div className="invalid-feedback d-block">
                      Molimo izaberite igrača.
                    </div>
                )}
                <Form.Control.Feedback type="invalid">Molimo izaberite igrača.</Form.Control.Feedback>
              </Form.Group>
            </Row>

            <div className="border-dashed border-bottom my-3"/>

            <Row className="mb-3">
              <Form.Group as={Col} md="7" controlId="transfer">
                <Form.Label as="legend" column md="12" className="mb-3">
                  Ispisnica
                </Form.Label>
                <Col md="12">
                  <Form.Check
                      inline
                      type='radio'
                      id='allow_transfer_any_club'
                      label='Može da pređe u bilo koji klub'
                      name='transfer'
                      onChange={handelInput}
                      checked={item.transfer_option === "allow_transfer_any_club"}
                      disabled={mode !== 'edit'}
                  />
                  <Form.Check
                      inline
                      type='radio'
                      id='allow_transfer_specific_club'
                      label='Može da pređe u'
                      name='transfer'
                      onChange={handelInput}
                      checked={item.transfer_option === "allow_transfer_specific_club"}
                      disabled={mode !== 'edit'}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Col} md="5" controlId="specific_club_entities_id">
                <Form.Label className="mb-4">&nbsp;</Form.Label>
                <Form.Select name="specific_club_entities_id" isInvalid={errors.specific_club_entities_id} value={item.specific_club_entities_id || ''} onChange={handelInput} disabled={transferOption !== 'allow_transfer_specific_club' || mode !== 'edit'}>
                  <option value="">Izaberi</option>
                  {club.map(p => (
                      <option key={p.entities_id} value={p.entities_id}>
                        {p.name}
                      </option>
                  ))}
                </Form.Select>
              </Form.Group>
              {errors.transfer_option && (
                  <div className="text-danger small mt-1">Molimo izaberite jednu od opcija za ispisnicu.</div>
              )}
            </Row>

            {selectedPlayer &&
                selectedPlayer.players_year >= 14 &&
                selectedPlayer.players_year <= 17 &&
                selectedPlayer.is_home_club === 1 && (
                    <>
                      <div className="border-dashed border-bottom my-3"/>
                      <Row className="mb-3">
                        <Form.Group as={Col} md="7" controlId="compensation">
                          <Form.Label as="legend" column md="12" className="mb-3">
                            Trening kompenzacija
                          </Form.Label>
                          <Col md="12">
                            <Form.Check
                                inline
                                type='radio'
                                id='tc_exempted'
                                label='Ne mora da se plati'
                                name='compensation'
                                onChange={handelInput}
                                checked={item.compensation_option === "tc_exempted"}
                                disabled={mode !== 'edit'}
                            />
                            <Form.Check
                                inline
                                type='radio'
                                id='tc_paid'
                                label='Plaćena'
                                name='compensation'
                                onChange={handelInput}
                                checked={item.compensation_option === "tc_paid"}
                                disabled={mode !== 'edit'}
                            />
                          </Col>
                        </Form.Group>
                      </Row>
                      {errors.compensation_option && (
                          <div className="text-danger small mt-1">Molimo izaberite jednu za trening kompenzaciju.</div>
                      )}
                    </>
                )}
            <div className="border-dashed border-bottom my-3"/>
            {mode === 'edit' && (
              <Button type="submit">Sačuvaj</Button>
            )}
          </Form>
        </Card.Body>
      </Card>
  );
}
